import React, { useEffect } from "react";
import SEO from "../common/SEO";
import BreadcrumbOne from "../common/breadcrumb/BreadcrumbOne";
import KYouthFooter from "../common/footer/KYouthFooter";
import KYouthHeader from "../common/header/KYouthHeader";
import KYouthAboutUsTeam from "../components/about-us-one/KYouthAboutUsTeam";
import KYouthService from "../components/about-us-one/KYouthService";
import KYouthAbout from "../components/about/KYouthAbout";
import KYouthAbout2 from "../components/about/KYouthAbout2";
import KYouthAbout3 from "../components/about/KYouthAbout3";
import KYouthPartners from "../components/instructor/KYouthPartners";
import KYouthTestimonialSection from "../components/testimonial-section/KYouthTestimonialSection";
import KYouthFaq from "./innerpages/KYouthFaq";

const RedirectPage = () => {
  useEffect(() => {
    window.location.pathname = "/k-youth";
  }, []);

  return (
    <>
      <SEO title="K-Youth" />

      <KYouthHeader />

      <BreadcrumbOne
        title="K-Youth"
        rootUrl="/"
        parentUrl="Home"
        currentUrl="About Us"
      />

      <KYouthAbout />

      <KYouthService />

      <KYouthAbout2 />

      <KYouthAbout3 />

      <KYouthPartners />

      <KYouthAboutUsTeam />

      {/* <HomeTwoTestimonial /> */}

      <KYouthFaq />

      <KYouthTestimonialSection classes="counterup-overlay-top" />

      <KYouthFooter />
    </>
  );
};

export default RedirectPage;
